// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__P9KfR","list":"PatternAutocomplete_list__1ZBJJ"};